import '../../../test.css';
import React, { useCallback, useEffect, useState, forwardRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment";
import { getMessageUserName } from 'pages/HistoryPage/HistoryPage.config';
import { deleteMessageFile } from "../../../redux_toolkit/reducers/history/historyApi";
import { setNotification } from "../../../redux_toolkit/reducers/notification/notificationSlice";
import { clearHistoryMessageFile } from "../../../redux_toolkit/reducers/history/historySlice";

const Transcript = forwardRef(({ transcript, visitorPartner }, ref) => {
  const dispatch = useDispatch();
  const { partnerTeam } = useSelector(({ agents })=> agents);
  const [messages, setMessages] = useState(transcript?.chatHistory || []);

  useEffect(() => {
    setMessages(transcript?.chatHistory || []);
  }, [transcript?.chatHistory]);

  const senderName = useCallback((id) => {
    return getMessageUserName(id, partnerTeam, visitorPartner);
  }, [partnerTeam, visitorPartner]);

  const handleDeleteFile = async (message) => {
    const messageId = message._id || message.id;
    if (!messageId || !transcript.partnerId || !transcript.chatId) return;

    setMessages((prev) =>
      prev.map((m) =>
        (m._id || m.id) === messageId ? { ...m, file: '' } : m
      )
    );
    dispatch(clearHistoryMessageFile({ chatId: transcript.chatId, messageId }));

    const res = await deleteMessageFile(transcript.partnerId, transcript.chatId, messageId);
    if (res instanceof Error) {
      dispatch(setNotification({ type: res.message || 'Delete file failed', message: 'error' }));
      return;
    }

    dispatch(setNotification({ type: 'Image deleted', message: 'success' }));
  };

  return (
      <div className="transcript-new">
          <span>rating: {transcript.rating || ' -- '}</span>
          <span>Date: {messages[0] && moment(new Date(messages[0].date)).format('DD-MM-YYYY')}</span>
          <div className="messages-new">
              {messages.map((message) => {
                  const isBot = !message.userId;
                  const isVisitor = visitorPartner._id === message.userId;
                  let messageNew = message.message;
                  if(isBot){
                      const [userPartnerId, action] = message.message.split('_');
                      const name = senderName(userPartnerId).name || message.name;
                      messageNew = name + ' ' + action;
                  }
                  const messageId = message._id || message.id;
                  const hasFile = !!message.file;
                  const fileType = hasFile ? message.file.split('.').reverse()[0] : '';

                  return (
                      <div key={messageId || message.date} className={isBot ? 'log' : isVisitor ? 'visitor' : 'agent'}>
                          {messageNew}
                          {hasFile && <>{
                              (fileType === 'mp4' && <video controls="controls" src={message.file} />)
                              || <div>
                                  <a href={message.file} target="_blank" rel="noreferrer"><img src={message.file} alt="" /></a>
                                  <span
                                    style={{ cursor: 'pointer', marginLeft: 8 }}
                                    onClick={() => handleDeleteFile(message)}
                                  >
                                    &#128473;
                                  </span>
                                </div>
                          }</>}
                          <span>{moment(new Date(message.date)).format('HH:mm:ss')}</span>
                      </div>
                  );
              })}
          </div>
      </div>
  );
});

export { Transcript };
